// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__hPdbY","field":"styles_field__2akpW","fieldCol":"styles_fieldCol__2waxO","diffCol":"styles_diffCol__j3BWl","diff":"styles_diff__OIK54"};